
import Map1 from "../../../assets/filled/Map1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Map1Icon({ className, dataTestid = "Map1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Map1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
